<template>
  <div>
    <!-- alerta -->
    <Alert
      :alert="alert"
      :type="alertType"
      :title="alertTitle"
      :message="alertMessage"
    />
    <template v-if="skeletonLoader">
      <v-skeleton-loader
        type="table-heading, table-thead, table-tbody@2, table-tfoot"
      >
      </v-skeleton-loader>
    </template>
    <template v-else>
      <!-- tabla -->
      <v-card>
        <v-card-title class="text-h6 text-md-h5 font-weight-bold primary--text">
          <v-row>
            <v-col 
              cols="12"
              sm="8"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn 
                    fab 
                    small 
                    exact 
                    color="primary" 
                    class="mr-4"
                    v-bind="attrs" 
                    v-on="on" 
                    @click="regresar"
                  >
                    <v-icon> mdi-arrow-left </v-icon>
                  </v-btn>
                </template>
                <span>Regresar</span>
              </v-tooltip>

              Habilidades: {{ competencia.competencia }}
            </v-col>

            <template v-if="perfilAdminNacional || perfilLiderNacional">
              <v-col 
                cols="12"
                sm="4"
              >
                <div class="d-flex align-center">
                  <v-text-field
                    outlined
                    dense
                    hide-details
                    append-icon="mdi-magnify"
                    label="Buscar Habilidad"
                    class="mr-4"
                    v-model="searchTable"
                  >
                  </v-text-field>

                  <v-btn
                    exact
                    color="primary"
                    @click="abrirDialog"
                  >
                    Asociar
                  </v-btn> 
                </div>
              </v-col>
            </template>
          </v-row>
        </v-card-title>

        <v-data-table 
          fixed-header 
          height="calc(100vh - 220px)"
          class="elevation-2"
          :headers="headersTable" 
          :items="habilidadesCompetencia" 
          :search="searchTable"
          :footer-props="{ 'items-per-page-options': [50, 100, -1] }"
        >
          <template v-slot:[`item.acciones`]="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon 
                  color="primary" 
                  class="mr-2" 
                  v-bind="attrs" 
                  v-on="on"
                  @click="detallesHabilidad(item.categoria_id)"
                >
                  mdi-eye
                </v-icon>
              </template>
              <span>Detalles Habilidad</span>
            </v-tooltip>

            <template v-if="((perfilAdminNacional || perfilLiderNacional) && competencia.tipo_competencia_id == 2)">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon  
                    color="primary" 
                    class="mr-2" 
                    v-bind="attrs" 
                    v-on="on"
                    @click="registrarExpertoNacional(item.categoria_id, item.competencia_id)">
                    mdi-account-multiple-plus
                  </v-icon>
                </template>
                <span>Registrar Experto Nacional</span>
              </v-tooltip>
            </template>

            <template v-if="!perfilExpertoRegional">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon 
                    color="primary" 
                    class="mr-2" 
                    v-bind="attrs" 
                    v-on="on"
                    @click="registrarParticipante(item.categoria_id, item.competencia_id)"
                  >
                    mdi-account-group
                  </v-icon>
                </template>
                <span>Registrar Participantes</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon 
                    color="primary" 
                    class="mr-2" 
                    v-bind="attrs" 
                    v-on="on"
                    @click="registrarGanador(item.categoria_id, item.competencia_id)"
                  >
                    mdi-flag-checkered
                  </v-icon>
                </template>
                <span>Registrar Ganadores</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon 
                    color="primary" 
                    v-bind="attrs" 
                    v-on="on"
                    @click="registrarExpertoRegional(item.competencia_id, item.categoria_id)"
                  >
                    mdi-account-plus
                  </v-icon>
                </template>
                <span>Registrar Experto Regional</span>
              </v-tooltip>
            </template>


            <!-- <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon 
                  color="error" 
                  v-bind="attrs" 
                  v-on="on"
                  @click="activarAlertaEliminar(item.categoria_id, item.competencia_id)"
                >
                  mdi-delete
                </v-icon>
              </template>
              <span>Eliminar</span>
            </v-tooltip> -->
          </template>

          <template v-slot:top>
            <v-dialog 
              persistent 
              v-model="dialogForm" 
              max-width="520px"
            >
              <v-card :loading="loadingForm">
                <v-card-title class="justify-center">
                  <p class="text-h5 font-weight-bold primary--text">
                    {{ formTitle }}
                  </p>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row justify="center">
                      <v-col 
                        cols="12" 
                        sm="10"
                      >
                        <v-form 
                          ref="form" 
                          v-model="form"
                        >
                          <v-text-field 
                            outlined 
                            dense 
                            disabled 
                            type="text" 
                            label="Competencia"
                            v-model="competenciaSeleccionada"
                          >
                          </v-text-field>

                          <v-select 
                            outlined 
                            dense 
                            label="Habilidad*" 
                            :items="habilidades" 
                            item-value="id"
                            item-text="categoria" 
                            v-model="habilidad" 
                            :rules="habilidadReglas"
                            @change="seleccionarModalidad(habilidad)"
                          >
                          </v-select>
                    
                          <v-select 
                            outlined 
                            dense
                            :disabled="competencia.competencia_id !== null"
                            label="Modalidad*" 
                            :items="modalidades" 
                            item-value="id"
                            item-text="modalidad" 
                            v-model="modalidad" 
                            :rules="modalidadReglas"
                          >
                          </v-select>
                          
                          <v-text-field 
                            outlined 
                            dense 
                            type="number" 
                            label="Número de Participantes*"
                            v-model="numeroParticipantes" 
                            :rules="numeroParticipantesReglas"
                            @keyup.prevent="gruposParticipantes(numeroParticipantes)"
                            @change="gruposParticipantes(numeroParticipantes)"
                          >
                          </v-text-field>

                          <v-text-field 
                            outlined 
                            dense 
                            disabled 
                            type="number" 
                            label="Número de Grupos"
                            v-model="cantidadGrupos"
                          >
                          </v-text-field>
                        </v-form>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn 
                    text 
                    color="error" 
                    @click="cerrarDialog"
                  >
                    Cancelar
                  </v-btn>

                  <template v-if="editedIndex === -1">
                    <v-btn 
                      text 
                      exact 
                      color="primary" 
                      @click="asignar"
                    >
                      Asociar
                    </v-btn>
                  </template>

                  <template v-else>
                    <v-btn 
                      text 
                      exact 
                      color="primary" 
                      @click="actualizar"
                    >
                      Actualizar
                    </v-btn>
                  </template>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
        </v-data-table>

        <!-- <v-dialog 
          v-model="dialogDelete" 
          max-width="480px"
        >
          <v-card>
            <v-card-title class="justify-center text-h6">
              ¿Desea eliminar la habilidad?
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="closeDelete">
                Cancelar
              </v-btn>
              <v-btn
                text
                color="error"
                @click="eliminar"
              >
                OK
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog> -->
      </v-card>
    </template>
  </div>
</template>
  
<script>
import Alert from '../../../components/admin/Alert.vue'

export default {
  data: () => ({
    skeletonLoader: true,
    searchTable: null,

    alert: false,
    alertType: '',
    alertTitle: '',
    alertMessage: '',

    headersTable: [
      {
        text: "Habilidad",
        value: "categoria",
        align: "start",
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "Modalidad",
        value: "modalidad",
        align: "start",
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "# Participantes",
        value: "numero_participantes",
        align: "start",
        filterable: false,
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "# Grupos",
        value: "cantidad_grupos",
        align: "start",
        filterable: false,
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "Acciones",
        value: "acciones",
        align: "center",
        sortable: false,
        filterable: false,
        class: ["text-subtitle-1", "font-weight-black"],
      }
    ],

    form: true,
    loadingForm: false,

    dialogForm: false,
    dialogDelete: false,

    temCategoria_id: null,
    temCompetencia_id: null,

    competenciaSeleccionada: "",

    habilidad: null,
    habilidadReglas: [
      (v) => !!v || "Seleccione una habilidad"
    ],

    modalidad: null,
    modalidadReglas: [
      (v) => !!v || "Seleccione una modalidad"
    ],

    sede: "",
    sedeReglas: [
      (v) => !!v || "Seleccione una sede"
    ],

    cantidadGrupos: null,

    numeroParticipantes: null,
    numeroParticipantesReglas: [
      (v) => !!v || "Escriba un número de participantes",
      (v) => v > 0 || "El número debe ser mayor a cero"
    ],

    editedIndex: -1
  }),

  components: {
    Alert
  },

  mounted() {
    this.$store.dispatch("crearModalidades")
    this.$store.dispatch("gestionarHabilidades")
    this.$store.dispatch("gestionarExpertosNacionales", 0)
    this.$store.dispatch("gestionarHabilidadesCompetencia", this.$route.params.id_competencia)
    this.$store.dispatch("detalleCompetenciaWorldSkills", this.$route.params.id_competencia)
   
    setTimeout(() => {
      this.skeletonLoader = false
    }, 1000)
  },

  computed: {
    usuario() {
      return this.$store.getters.usuario
    },

    perfilAdminNacional() {
      return this.$store.getters.perfilAdminNacional
    },

    perfilLiderNacional() {
      return this.$store.getters.perfilLiderNacional
    },
    
    perfilEnlaceRegional() {
      return this.$store.getters.perfilEnlaceRegional
    },

    perfilExpertoRegional() {
      return this.$store.getters.perfilExpertoRegional
    },

    formTitle() {
      return this.editedIndex === -1 ? "Asociar Habilidad" : "Actualizar Habilidad"
    },

    competencia() {
      return this.$store.getters.obtenerCompetenciaWorldSkills;
    },

    habilidades() {
      if (this.competencia.competencia_id != null) {
        return this.$store.getters.obtenerHabilidadesCompetenciaPadre
      }
      return this.$store.getters.obtenerHabilidades;
    },

    modalidades() {
      return this.$store.getters.obtenerModalidades.filter((modalidad) => modalidad.id < 3)
    },

    expertoNacional() {
      return this.$store.getters.obtenerExpertoNacionalIdentificacion(this.usuario.identificacion)
    },

    habilidadesCompetencia() {  
      if (this.expertoNacional != null) {
        return this.$store.getters.obtenerHabilidadesCompetencia.filter(habilidadCompetencia => habilidadCompetencia.categoria_id == this.expertoNacional.categoria_id) 
      }
      return this.$store.getters.obtenerHabilidadesCompetencia;
    }
  },

  watch: {
    dialog(val) {
      val || this.cerrarDialog()
    },

    dialogDelete(val) {
      val || this.closeDelete()
    }
  },

  methods: {
    abrirDialog() {
      if (this.competencia.competencia_id != null) {
        this.$store.dispatch("gestionarHabilidadesCompetenciaPadre", this.competencia.competencia_id)
      }
      this.competenciaSeleccionada = this.competencia.competencia

      this.dialogForm = true;
    },

    gruposParticipantes(participantes) {
      if (this.modalidad == 2) {
        const calculo = participantes % 2;
        if (calculo == 0) {
          this.cantidadGrupos = participantes / 2;
        }
        else {
          this.alertType    = "error--text";
          this.alertTitle   = 'Error';
          this.alertMessage = "El número de participantes no coincide con la modalidad";
          this.alert        = true;

          setTimeout(() => {
            this.alert = false;
          }, 3000);
        }
      }
      else {
        this.cantidadGrupos = this.numeroParticipantes
      }
    },

    seleccionarModalidad(idHabilidad) {
      const habilidad = this.habilidades.find(habilidad => habilidad.id == idHabilidad)
      this.modalidad = habilidad.modalidad_id
    },

    deleteItem() {
      this.dialogDelete = true
    },

    deleteItemConfirm() {
      this.closeDelete()
    },

    cerrarDialog() {
      this.editedIndex = -1
      this.dialogForm = false
      this.alert = false

      this.$refs.form.reset()
    },

    closeDelete() {
      this.editedIndex = -1
      this.dialogDelete = false
    },

    asignar() {
      if (this.$refs.form.validate()) {
        const habilidadCompetencia = {
          competencia_id:       this.$route.params.id_competencia,
          categoria_id:         this.habilidad,
          modalidad_id:         this.modalidad,
          numero_participantes: this.numeroParticipantes,
          cantidad_grupos:      this.cantidadGrupos,
          sede_id:              this.sede
        }

        if (this.cantidadGrupos > 0) {
          this.$store.dispatch("asignarHabilidadCompetencia", habilidadCompetencia)
          .then((response) => {
            if (response.status == "success") {
              this.loadingForm = false;
              this.cerrarDialog();

              this.alertType    = "success--text";
              this.alertTitle   = "Asociada";
              this.alertMessage = response.message;
              this.alert        = true;

              this.skeletonLoader = true

              this.$store.dispatch("gestionarHabilidadesCompetencia", this.$route.params.id_competencia);

              setTimeout(() => {
                this.alert = false;
                this.skeletonLoader = false
              }, 1000)
            }
            else {
              this.loadingForm  = false
              this.alertType    = "error--text";
              this.alertTitle   = "Error";

              for (const error in response.message) {
                this.alertMessage = response.message[error]
              }
              
              this.alert = true;

              setTimeout(() => {
                this.alert = false
              }, 3000)
            }
          })
          .catch(() => { });
        }
        else {
          this.alertType    = "error--text";
          this.alertTitle   = "Error";
          this.alertMessage = "El número de participantes no coincide con la modalidad";
          this.alert        = true;

          setTimeout(() => {
            this.alert = false;
          }, 3000);
        }
      }
    },

    activarAlertaEliminar(categoria_id, competencia_id) {
      this.temCategoria_id = categoria_id;
      this.temCompetencia_id = competencia_id;
      this.dialogDelete = true;
    },

    eliminar() {
      this.dialogDelete = false;
      const habilidadCompetencia = {
        categoria_id: this.temCategoria_id,
        competencia_id: this.temCompetencia_id
      };

      this.$store.dispatch("eliminarHabilidadCompetencia", habilidadCompetencia)
        .then((response) => {
          if (response.status == "success") {
            this.alertType    = "success--text";
            this.alertTitle   = "Eliminada";
            this.alertMessage = response.message;
            this.alert        = true;

            this.$store.dispatch("gestionarHabilidadesCompetencia", this.$route.params.id_competencia)

            setTimeout(() => {
              this.alert = false
            }, 2000)
          }
          else {
            this.loadingForm  = false
            this.alertType    = "error--text";
            this.alertTitle   = "Error";

            for (const error in response.message) {
              this.alertMessage = response.message[error][0]
            }
            
            this.alert = true;

            setTimeout(() => {
              this.alert = false
            }, 3000)
          }
        })
        .catch(() => { });
    },

    detallesHabilidad(habilidad) {
      this.$router.push({
        name: "habilidad-detalles",
        params: { id_habilidad: habilidad }
      });
    },

    registrarParticipante(categoria, competencia) {
      this.$router.push({
        name: "participantews-gestionar",
        params: { id_habilidad: categoria, id_competencia: competencia }
      })
    },

    registrarGanador(categoria, competencia) {
      this.$router.push({
        name: "ganador-gestionar",
        params: { id_categoria: categoria, id_competencia: competencia }
      })
    },

    registrarExpertoRegional(competencia, categoria) {
      this.$router.push({
        name: "expertows-gestionar",
        params: { id_competencia: competencia, id_categoria: categoria }
      })
    },

    registrarExpertoNacional(categoria, competencia) {
      this.$router.push({
        name: "expertows-nacional-gestionar",
        params: { id_competencia: competencia, id_categoria: categoria }
      })
    },

    regresar() {
      this.$router.back()
    }
  }
}
</script>